import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import jwt from 'jsonwebtoken';
const { REACT_APP_CONNECTION_INFO_BASE_URL, REACT_APP_APP_REGISTRY_API, REACT_APP_APP_REGISTRY_ISS, REACT_APP_APP_REGISTRY_AUD, REACT_APP_APP_REGISTRY_PRIVATE_KEY, REACT_APP_APP_ID } = process.env;

// import jwt_decode from "jwt-decode";

export const loginAsync = createAsyncThunk(
    'user/login',
    async (payload) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                username: payload.username,
                password: payload.password
            })
        };
        const response = await fetch(`${REACT_APP_CONNECTION_INFO_BASE_URL}/signin`, requestOptions)
        const data = await response.json();
        return data;
    }
)

export const getAppsAsync = createAsyncThunk(
    'user/getApps',
    async () => {
        const appsTimestamp = Math.floor(Date.now() / 1000) + 1000;
        var appsPayload = {
            "aud": REACT_APP_APP_REGISTRY_AUD,
            "exp": appsTimestamp,
            "iss": REACT_APP_APP_REGISTRY_ISS,
            "usertoken": localStorage.getItem('accessToken')
        };

        var appsPrivateKey = REACT_APP_APP_REGISTRY_PRIVATE_KEY.replace(/\\n/g, '\n');

        var appsSignOptions = {
            "algorithm": "RS256"
        };


        var appsToken = jwt.sign(appsPayload, appsPrivateKey, appsSignOptions);

        console.log("JWT  appsToken==>>", appsToken);

        const requestOptions = {
            method: 'GET',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                Authorization: `Bearer ` + appsToken,
            }
        };

        const response = await fetch(`${REACT_APP_APP_REGISTRY_API}`, requestOptions)
        const data = await response.json();
        console.log("APPS resp===>>", data)
        return data;


        // fetch(`${REACT_APP_APP_REGISTRY_API}`, requestOptions)
        //     .then(response => response.json())
        //     .then((resp) => {
        //         console.log("APPS resp===>>", resp)
        //     });

    }
)

export const getCurrentUserAsync = createAsyncThunk(
    'user/getCurrent',
    async () => {
        const resp = localStorage.getItem("currentUser");
        // console.log("resp===>>", resp)
        if (resp) {
            const userObj = JSON.parse(resp)
            return userObj;
        } else {
            return {}
        }
    }
);

export const setCurrentUserAsync = createAsyncThunk(
    'user/getCurrent',
    async (payload) => {
        const userObj = JSON.stringify(payload)
        const resp = await localStorage.setItem("currentUser", userObj);
        if (resp) {
            return userObj;
        }
    }
);

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        user: {
            isSigned: false
        },
        otherUsers: [],
        appDetails: {
            CurrentAppID:REACT_APP_APP_ID
        }
    },
    reducers: {
        signin: (state, action) => {
            // const userdata = action.payload;
            localStorage.setItem("currentUser", JSON.stringify(action.payload));
            state.user = action.payload;
        },
        signout: (state) => {
            localStorage.clear()
            state.user = {};
        },
        setOtherUsers: (state, action) => {
            localStorage.setItem("otherUsers", JSON.stringify(action.payload));
            state.otherUsers = action.payload
        }
    }, extraReducers: {
        [getCurrentUserAsync.fulfilled]: (state, action) => {
            state.user = action.payload;
            state.currentAppPermissions = action.payload.permissions && action.payload.permissions.find(pl => pl.AppID === state.appDetails.CurrentAppID).AccessPermissions.filter(ap => ap.Permission===1).map(p => p.AccessName)
        },
        [getAppsAsync.pending]: (state) => {
            state.appsState = 'loading';
            state.apps = null
        }, [getAppsAsync.fulfilled]: (state, action) => {
            state.appsState = 'success'
            state.apps = action.payload
        },
        [getAppsAsync.rejected]: (state, action) => {
            state.appsState = 'error';
            state.apps = null
        }
    },
});

export const { signin, signout, setOtherUsers } = userSlice.actions;

/* ── WHICH APPLICATIONS THIS USER MAY PICK ──────────────────────────────────
   The app registry returns every application Witmeg has. A customer only holds a licence
   for some of them, and the org registry's login response now says which - see the
   Licenses array read in views/Login/index.js.

   Two lists, and they are not interchangeable:

     selectAllApps       - every application. For turning an ApplicationID into a name,
                           which has to work even for something built against an app this
                           customer has no licence for.
     selectLicensedApps  - only the ones they hold. For a dropdown where they choose.

   Using the filtered list for a name lookup would leave a blank where the name should be.
   Using the full list in a picker would offer applications they cannot use. */

/** The full registry list, whatever the licences say. */
export const selectAllApps = (state) => state.user?.apps?.Result || [];

/**
 * The licences read at login. Falls back to the standalone localStorage entry, which
 * covers a session that signed in before licences were being stored - without it, an
 * already-logged-in user would see an empty application list until they signed in again.
 */
const licensesOf = (state) => {
  const fromStore = state.user?.user?.licenses;
  if (Array.isArray(fromStore)) return fromStore;

  try {
    const stored = JSON.parse(localStorage.getItem("licenses") || "[]");
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
};

/* A licence counts only if it is actually assigned and has not been revoked - the array
   holds both, and treating a deleted licence as access would show applications the
   customer no longer pays for. */
const isUsableLicense = (licence) =>
  Boolean(licence && licence.ApplicationID && licence.IsLicenseAssigned && !licence.IsLicenseDeleted);

/**
 * Applications this user may choose from.
 *
 * A special user - Witmeg's own staff - gets everything. They build the global reports
 * that all customers see, so they need applications no single customer holds a licence
 * for. Everyone else gets what their licences allow.
 */
export const selectLicensedApps = (state) => {
  const apps = selectAllApps(state);
  if (!apps.length) return [];

  /* Stored by login from the registry's user record. localStorage keeps it as a string,
     hence the comparison rather than a truthiness check. */
  const isSpecialUser =
    localStorage.getItem("IsSpecialUser") === "true" || state.user?.user?.userData?.IsSpecialUser === true;
  if (isSpecialUser) return apps;

  const allowed = new Set(licensesOf(state).filter(isUsableLicense).map((l) => l.ApplicationID));
  return apps.filter((app) => allowed.has(app.ApplicationID));
};

export default userSlice.reducer;